
import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { ShipmentDetailsDto } from "./shipment-details-dto";

export class ShippmentDetailsResponse extends GlobalResponseObject{
    data?: ShipmentDetailsDto;

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data string
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: ShipmentDetailsDto) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}